module.exports = __webpack_public_path__ + "static/media/bandeira-brasil-thumbnail.7910a3e7.webp";